import type { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";
import {
  exchangedArticleRefsFromStoredLineItem,
  getExchangedArticle,
  type ExchangedArticle,
} from "@babackapp/return-variables-registry";

export type { ExchangedArticle };

/**
 * Maps a stored line item onto the shared `getExchangedArticle` rule (portal
 * and emails use the same one): the article the customer gets back when it is
 * *another* article than the returned one. Null for a plain size swap, which
 * keeps the "38 → 39" rendering.
 */
export function getLineItemExchangedArticle(
  lineItem: Pick<
    ReturnRequestLineItemDto,
    "resolution" | "new_variant" | "variant" | "product" | "image" | "title"
  >,
): ExchangedArticle | null {
  // Same separator as Shopify variant titles ("37 / Cuir"), shown next to it.
  return getExchangedArticle({
    ...exchangedArticleRefsFromStoredLineItem(lineItem),
    separator: " / ",
  });
}
